const lifeInsuranceEventTypes = {
    payment: 'Versement ponctuel',
    withdrawal: 'Rachat ponctuel',
    recurrentPayment: 'Versements programmés',
    recurrentWithdrawal: 'Rachats partiels programmés\n',
};

export default lifeInsuranceEventTypes;
